<div>
  <h3>Primary:</h3>
  <div fxLayout="row wrap" fxLayoutGap="10px">
    @for (primary of colors; track primary) {
      <div>
        <div class="p{{primary}} swatch">
          {{primary}} Contrast
        </div>
      </div>
    }
  </div>
</div>
<div>
  <h3>Accent:</h3>
  <div fxLayout="row wrap" fxLayoutGap="10px">
    @for (accent of colors; track accent) {
      <div>
        <div class="a{{accent}} swatch">
          {{accent}} Contrast
        </div>
      </div>
    }
  </div>
</div>
<div>
  <h3>Warn:</h3>
  <div fxLayout="row wrap" fxLayoutGap="10px">
    @for (warn of colors; track warn) {
      <div>
        <div class="w{{warn}} swatch">
          {{warn}} Contrast
        </div>
      </div>
    }
  </div>
</div>
<div>
  <h3>Foreground:</h3>
  <div fxLayout="row wrap" fxLayoutGap="10px">
    @for (foreground of foregrounds; track foreground) {
      <div>
        <div class="foreground-{{foreground}} swatch">
        </div>
        <div>
          <span>{{foreground}}</span>
        </div>
      </div>
    }
  </div>
</div>

<div>
  <h3>Background:</h3>
  <div fxLayout="row wrap" fxLayoutGap="10px">
    @for (background of backgrounds; track background) {
      <div>
        <div class="background-{{background}} swatch">
        </div>
        <div>
          <span>{{background}}</span>
        </div>
      </div>
    }
  </div>
</div>
